(() => {
  const KEY = 'effie-wishlist';
  const get = () => { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } };
  const set = (l) => { localStorage.setItem(KEY, JSON.stringify(l)); sync(); };
  const has = (h) => get().includes(h);
  const toggle = (h) => { const l = get(); const added = !l.includes(h); set(added ? [...l, h] : l.filter(x => x !== h)); return added; };
  const handleFrom = (el) => {
    const a = el.dataset.handle ? null : el.querySelector('a[href*="/products/"]');
    if (el.dataset.handle) return el.dataset.handle;
    if (!a) return null;
    return new URL(a.href, location.origin).pathname.split('/products/')[1]?.split(/[/?#]/)[0] || null;
  };
  const heart = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-7.5-10.2A4.3 4.3 0 0 1 12 7.6a4.3 4.3 0 0 1 7.5 2.7c0 5.6-7.5 10.2-7.5 10.2z" fill="var(--fill,none)" stroke="currentColor" stroke-width="1.4"/></svg>';
  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
  let feedbackTimer;

  function decorate() {
    document.querySelectorAll('main .card-product, main card-product, main .shoppable-product-card, main shoppable-product-card').forEach(card => {
      if (card.querySelector(':scope > .effie-fav')) return;
      const h = handleFrom(card); if (!h || /gift/i.test(h)) return;
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'effie-fav'; b.dataset.favHandle = h; b.innerHTML = heart;
      b.title = 'Add to Wishlist';
      card.style.position = card.style.position || 'relative';
      card.appendChild(b);
    });
    sync();
  }
  function sync() {
    document.querySelectorAll('[data-fav-handle]').forEach(b => {
      const on = has(b.dataset.favHandle);
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-label', on ? 'Remove from Wishlist' : 'Add to Wishlist');
      b.title = on ? 'Remove from Wishlist' : 'Add to Wishlist';
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(c => c.textContent = get().length || '');
  }


  function sendKlaviyo(handle, added) {
    const list = get();
    fetchItems([handle]).then((items) => {
      const p = items && items[0]; if (!p) return;
      const img = p.featured_image ? (String(p.featured_image).startsWith('//') ? 'https:' + p.featured_image : p.featured_image) : '';
      const props = {
        ProductName: p.title, ProductID: p.id, Handle: handle,
        URL: location.origin + '/products/' + handle, ImageURL: img,
        Price: (p.price / 100).toFixed(2), WishlistCount: list.length,
        WishlistHandles: list, WishlistURL: location.origin + '/pages/wishlist'
      };
      const k = window.klaviyo || (window._learnq = window._learnq || []);
      const ev = added ? 'Added to Wishlist' : 'Removed from Wishlist';
      if (window.klaviyo && typeof window.klaviyo.track === 'function') window.klaviyo.track(ev, props);
      else k.push(['track', ev, props]);
    }).catch(() => {});
  }
  function showFeedback(added) {
    let feedback = document.querySelector('[data-effie-wishlist-feedback]');
    if (!feedback) {
      feedback = document.createElement('div');
      feedback.className = 'effie-wishlist-feedback';
      feedback.dataset.effieWishlistFeedback = '';
      feedback.setAttribute('role', 'status');
      feedback.setAttribute('aria-live', 'polite');
      document.body.appendChild(feedback);
    }
    feedback.textContent = added ? 'Added to wishlist' : 'Removed from wishlist';
    feedback.classList.add('is-visible');
    clearTimeout(feedbackTimer);
    feedbackTimer = setTimeout(() => feedback.classList.remove('is-visible'), 1800);
  }
  document.addEventListener('effie:card-product-changed', e => {
    const card = e.target;
    const button = card.querySelector(':scope > .effie-fav');
    if (!button || !e.detail?.handle) return;
    button.dataset.favHandle = e.detail.handle;
    sync();
  });
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-fav-handle]'); if (!b) return;
    e.preventDefault(); e.stopPropagation(); const added = toggle(b.dataset.favHandle); showFeedback(added); renderDrawer(); sendKlaviyo(b.dataset.favHandle, added);
    if (document.querySelector('[data-effie-wishlist]')) renderPage();
  }, true);

  async function fetchItems(list) {
    return (await Promise.all(list.map(h => fetch(`/products/${encodeURIComponent(h)}.js`).then(r => r.ok ? r.json() : null).catch(() => null)))).filter(Boolean);
  }

  async function renderDrawer() {
    const section = document.querySelector('[data-effie-wishlist-drawer]');
    const root = section?.querySelector('[data-effie-wishlist-drawer-items]');
    if (!section || !root) return;
    const list = get();
    section.hidden = !list.length;
    if (!list.length) { root.innerHTML = ''; return; }
    const requested = list.join('|');
    root.dataset.requested = requested;
    const items = await fetchItems(list);
    if (root.dataset.requested !== requested) return;
    const fmt = (c) => (window.Shopify?.formatMoney ? Shopify.formatMoney(c) : new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify?.currency?.active) || 'USD' }).format(c / 100));
    root.innerHTML = items.map(p => `
      <article class="effie-cart-wishlist__item">
        <a href="${escapeHtml(p.url)}" class="effie-cart-wishlist__media">${p.featured_image ? `<img src="${escapeHtml(p.featured_image)}" alt="${escapeHtml(p.title)}" loading="lazy">` : ''}</a>
        <div class="effie-cart-wishlist__details">
          <a href="${escapeHtml(p.url)}" class="effie-cart-wishlist__product-title">${escapeHtml(p.title)}</a>
          <span class="effie-cart-wishlist__price">${escapeHtml(fmt(p.price))}</span>
        </div>
        <button type="button" class="effie-fav is-active" data-fav-handle="${escapeHtml(p.handle)}" aria-label="Remove from Wishlist" title="Remove from Wishlist">${heart}</button>
      </article>`).join('');
    section.hidden = !items.length;
  }

  async function renderPage() {
    const root = document.querySelector('[data-effie-wishlist]'); if (!root) return;
    const list = get();
    if (!list.length) { root.innerHTML = '<p class="effie-wl__empty">Your wishlist is empty. Tap the ♡ on any product to save it here.</p>'; return; }
    const items = await fetchItems(list);
    const fmt = (c) => (window.Shopify?.formatMoney ? Shopify.formatMoney(c) : new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify?.currency?.active) || 'USD' }).format(c / 100));
    root.innerHTML = items.map(p => `
      <div class="effie-wl__item" style="position:relative">
        <a href="${escapeHtml(p.url)}" class="effie-wl__media">${p.featured_image ? `<img src="${escapeHtml(p.featured_image)}" alt="${escapeHtml(p.title)}" loading="lazy">` : ''}</a>
        <button type="button" class="effie-fav is-active" data-fav-handle="${escapeHtml(p.handle)}">${heart}</button>
        <a href="${escapeHtml(p.url)}" class="effie-wl__title">${escapeHtml(p.title)}</a>
        <span class="effie-wl__price">${escapeHtml(fmt(p.price))}</span>
      </div>`).join('');
    sync();
  }

  const start = () => { decorate(); renderPage(); renderDrawer(); new MutationObserver(() => { clearTimeout(window.__effieFavT); window.__effieFavT = setTimeout(decorate, 50); }).observe(document.body, { childList: true, subtree: true }); };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
